import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../Reveal";
import { SERVICES, COMPANY } from "../../data/content";

const linkFor = (slug) => (slug === "supplies" ? COMPANY.productUrl : "/services");

export const ServicesGrid = () => (
  <section data-testid="services-grid" className="bg-sml-mist py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-12 items-end mb-14">
        <div className="lg:col-span-8">
          <Overline>What We Do</Overline>
          <Reveal>
            <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight text-sml-charcoal">
              Integrated Property Support Services
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <p className="text-sml-charcoal/70 leading-relaxed">
              From landscaped grounds to spotless facilities and fully stocked hygiene environments,
              we provide comprehensive services designed around the needs of your property.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const isExternal = s.slug === "supplies";
          const to = linkFor(s.slug);
          const Card = (
            <motion.article
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-white border border-sml-border rounded-sm overflow-hidden hover:-translate-y-1.5 hover:border-sml-forest transition-[transform,border-color] duration-300"
              data-testid={`service-card-${s.slug}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <span className="absolute top-4 left-4 font-mono-sml text-xs text-white/90 border border-white/40 rounded-sm px-2 py-1">
                  {s.num}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-display text-xl md:text-2xl text-sml-charcoal">{s.title}</h3>
                <p className="mt-1.5 text-sm font-medium text-sml-green">{s.sub}</p>
                <p className="mt-4 text-sm text-sml-charcoal/65 leading-relaxed">{s.desc}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-sml-forest group-hover:gap-3 transition-all">
                  {s.cta} <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </motion.article>
          );
          return isExternal ? (
            <a key={s.slug} href={to} target="_blank" rel="noopener noreferrer">{Card}</a>
          ) : (
            <Link key={s.slug} to={to}>{Card}</Link>
          );
        })}
      </div>
    </div>
  </section>
);
